import { IRow } from "@/Resources/types";
import { DataTableDataType } from "@/components/pageCards/dataTable/dataTableCard";
import { translate } from "@/translations/functions/hook";

import { Row } from "@tanstack/react-table";
import { get } from "lodash";

// TODO: Should not use any for types
export const drawerPointListSorting = (a: any, b: any) => {
  const getFraction = (p: any) =>
    p?.properties?.find((p: any) => p.key === "fraction")?.value;
  const getSortingString = (p: any) =>
    (
      p["name"] ||
      (getFraction(p) ? translate(`fraction.${getFraction(p)}`) : undefined) ||
      p.id
    )?.toLocaleUpperCase() || "";
  return (
    ("" + getSortingString(a)).localeCompare(getSortingString(b)) ||
    a?.id?.localeCompare(b.id)
  );
};

export const sortGridList = (
  list: IRow[],
  header: string,
  order: "asc" | "desc" = "asc",
) => {
  const getValue = (p: any) => {
    return String(get(p, header) || "").toLocaleUpperCase();
  };
  return list.sort(
    (a, b) =>
      getValue(a).localeCompare(getValue(b), undefined, {
        numeric: true,
        sensitivity: "base",
      }) * (order === "asc" ? 1 : -1),
  );
};

export const tableSortFn = (
  rowA: Row<DataTableDataType>,
  rowB: Row<DataTableDataType>,
  columnId: string,
) => {
  const a = rowA.renderValue(columnId);
  const b = rowB.renderValue(columnId);
  const aNum = getSortableNumber(a);
  const bNum = getSortableNumber(b);
  if (aNum !== undefined && bNum !== undefined) {
    return aNum - bNum;
  }
  return String(a).localeCompare(String(b), undefined, {
    numeric: true,
    sensitivity: "base",
  });
};

export const sortAlphabeticallyByProperty = (
  a: any,
  b: any,
  property: string = "name",
) => a[property]?.toLowerCase().localeCompare(b[property]?.toLowerCase());

export const compareNullableStrings = (
  a?: string | null,
  b?: string | null,
): number => {
  if (!a && b) return 1;
  if (a && !b) return -1;
  if (!a || !b) return 0;
  return a.localeCompare(b);
};

const getSortableNumber = (value: unknown) => {
  if (value == null) {
    return undefined;
  }
  if (typeof value === "string" && value.trim() === "") {
    return undefined;
  }
  const numericValue = Number(value);
  return Number.isNaN(numericValue) ? undefined : numericValue;
};
